import React, { useEffect, useState } from 'react';

//component
import Modal from "../Modal";

// style
import RightSidebarStyle from './style';

//img
import Close from '../../Assets/Close.svg'

import {connect} from "react-redux";
import {AddVideo, EditVideo, DeleteVideos} from "../../Redux/Actions/VideosAction"

function RightSideBar(props) {
    const [response, setResponse] = useState(false);
    const [VideoTitle, setVideoTitle] = useState('');
    const [VideoTitleError, setVideoTitleError] = useState('');
    const [VideoURL, setVideoURL] = useState('');
    const [VideoURLError, setVideoURLError] = useState('');
    const [OpenModal, setModal] = useState(false);

    useEffect(() => {
        if(props.data){
            setVideoTitle(props.data.title);
            setVideoURL(props.data.video_url);
        }
    }, [props]);

    const CloseSidebar = (e) => {
        e.preventDefault();
        setVideoTitle('');
        setVideoURL('');
        props.close();
    };


    const handleModal = (e, type) => {
        e.preventDefault();
        if(type !== 'delete'){
            setModal(type);
        } else {
            setVideoURLError('');
            setModal(type);
        }
    };

    useEffect(() => {
        setTimeout(function () {
            setResponse(true)
        }, 1000)
    }, []);

    const CloseModal = (e, type) => {
        e.preventDefault();
        if(type === 'delete_yes'){
            props.DeleteVideos(props.data.id);
            props.close();
            setModal(false)
        } else if(type === 'delete_no'){
            setModal(false)
        }
        else if(type === 'update_yes'){
            const data = {
                id: props.data.id,
                title: VideoTitle,
                video_url: VideoURL,
            };
            props.EditVideo(data);
            props.close();
            setModal(false)
        }
        else if(type === 'add_yes'){
            const data = {
                title: VideoTitle,
                video_url: VideoURL,
            };
            props.AddVideo(data);
            setVideoTitle('');
            setVideoURL('');
            props.close();
            setModal(false)
        }
        else if(type === 'add_no'){
            setModal(false)
        } else {
            setModal(false)
        }
        if(type === 'add_yes' || type === 'update_yes' || type === 'delete_yes') {
            setModal(false)
            setVideoTitle('')
            setVideoTitleError('')
            setVideoURL('')
            setVideoURLError('')
            props.close()
        }
        
    };

    const handleVideoTitle = (e) => {
        if(e.target.value.length < 161){
            setVideoTitle(e.target.value);
            setVideoTitleError('')
        } else {
            setVideoTitleError('Title must be less than 160 characters')
        }
    };

    const handleVideoURL = (e) => {
        setVideoURL(e.target.value);
        // if(e.target.value.length < 100 || e.target.value.length === 50){
        //     setVideoURL(e.target.value);
        //     setVideoURLError('')
        // } else {
        //     setVideoURLError('URL cant be more than 100 characters long')
        // }
    };

    useEffect(() => {
        props.edit_data && response && props.response({type: props.edit_data.status, message: props.edit_data.message});
    }, [props.edit_data]);

    useEffect(() => {
        props.delete_data && response && props.response({type: props.delete_data.status, message: props.delete_data.message});
    }, [props.delete_data]);

    useEffect(() => {
        props.add_data && response && props.response({type: props.add_data.status, message: props.add_data.message});
    }, [props.add_data]);

    return (
        <>
            {props && props.sidebar && <div onClick={(e) => CloseSidebar(e)} className='dark-overlay'/>}
            <div className={props && props.sidebar ? 'dark-background right-sidebar-wrap' : 'dark-background right-sidebar-wrap right-sidebar-wrap-close'}>
                <div className='d-flex justify-content-between align-items-center'>
                    <h5 className='text-uppercase text-white'>{props.Type} VIDEO</h5>
                    <img onClick={(e) => CloseSidebar(e)} src={Close} alt='Close' className='cursor-pointer' />
                </div>
                <form className='sidebar-form-wrap' id='SidebarForm'>
                    <div className='mt-4'>
                        <label className='text-grey-6 f-16 d-block mb-1'>Video Title<span className='text-danger'>*</span></label>
                        <input
                            value={VideoTitle}
                            onChange={(e) => handleVideoTitle(e)}
                            type='text'
                            id='VideoTitle'
                            placeholder='Enter Title'
                            className="w-100 input-style"
                            autoComplete="off"
                        />
                        {VideoTitleError && <p className='f-12 text-danger'>{VideoTitleError}</p>}
                    </div>
                    <div className='mt-4'>
                        <label className='text-grey-6 f-16 d-block mb-1'>Video URL<span className='text-danger'>*</span></label>
                        <textarea
                            value={VideoURL}
                            onChange={(e) => handleVideoURL(e)}
                            id='VideoURL'
                            placeholder='Enter URL'
                            className="w-100 text-input-style"
                            autoComplete="off"
                            style = {{resize:"none"}}
                        />
                        {VideoURLError && <p className='f-12 text-danger'>{VideoURLError}</p>}
                    </div>
                    <div className='mt-5 mb-5 text-center'>
                        {props.Type === 'Add' && <button
                            onClick={(e) => handleModal(e, 'add')}
                            className="form-button"
                            disabled = {!(VideoTitle && VideoURL)}
                        >
                            Save
                        </button>}
                        {props.Type === 'Edit' &&
                        <div className='d-flex align-items-center justify-content-center'>
                            <button
                                onClick={(e) => handleModal(e, 'delete')}
                                className="form-button form-button-ghost f-14 mr-2"
                            >
                                Delete
                            </button>
                            <button
                                disabled = {!(VideoTitle && VideoURL)}
                                onClick={(e) => handleModal(e, 'update')}
                                className="form-button ml-2 f-14"
                            >
                                Update
                            </button>
                        </div>
                        }
                    </div>
                </form>
            </div>
            {OpenModal && <Modal Name="this video" Type={OpenModal} Close={(e, type) => CloseModal(e, type)}/>}
            <RightSidebarStyle/>
        </>

    )
}

const mapStateToProps = ({VideosReducer}) => {
    const { loading, delete_data, add_data, edit_data } = VideosReducer;
    return { loading, delete_data, add_data, edit_data }
};

const mapDispatchToProps = {
    AddVideo,
    EditVideo,
    DeleteVideos,
};

export default connect(mapStateToProps, mapDispatchToProps)(RightSideBar);